export default __webpack_public_path__ + "assets/Logout.91f9.svg";